import React, { useState } from 'react';

export default function Contact() {
  const [form, setForm] = useState({ prenom:'', nom:'', email:'', projet:'', message:'' });
  const [sent, setSent] = useState(false);

  const handle = e => setForm({...form, [e.target.name]: e.target.value});

  const submit = () => {
    if (!form.prenom || !form.email || !form.message) return;
    setSent(true);
  };

  return (
    <div style={s.page}>
      <div style={s.sLabel}>Parlons-nous</div>
      <h2 style={s.h2}>Démarrer un projet</h2>
      <p style={s.sub}>Décrivez votre projet et nous vous répondons dans les 24 heures.</p>
      {sent ? (
        <div style={s.success}>
          ✅ Message envoyé ! On vous répond sous 24h.
        </div>
      ) : (
        <div style={s.form}>
          <div style={s.row}>
            <div style={s.group}>
              <label style={s.label}>Prénom</label>
              <input style={s.input} name="prenom" placeholder="Jean" value={form.prenom} onChange={handle}/>
            </div>
            <div style={s.group}>
              <label style={s.label}>Nom</label>
              <input style={s.input} name="nom" placeholder="Tremblay" value={form.nom} onChange={handle}/>
            </div>
          </div>
          <div style={s.group}>
            <label style={s.label}>Courriel</label>
            <input style={s.input} name="email" type="email" placeholder="vous@exemple.com" value={form.email} onChange={handle}/>
          </div>
          <div style={s.group}>
            <label style={s.label}>Type de projet</label>
            <input style={s.input} name="projet" placeholder="Site web, application, identité visuelle..." value={form.projet} onChange={handle}/>
          </div>
          <div style={s.group}>
            <label style={s.label}>Décrivez votre projet</label>
            <textarea style={s.textarea} name="message" placeholder="Parlez-nous de votre idée..." value={form.message} onChange={handle}/>
          </div>
          <button style={s.btn} onClick={submit}>Envoyer le message ✦</button>
        </div>
      )}
    </div>
  );
}

const s = {
  page:    { background: '#080808', color: '#F0F0F0', minHeight: '100vh', padding: '120px 40px 80px', maxWidth: '800px', margin: '0 auto' },
  sLabel:  { fontSize: '0.75rem', letterSpacing: '0.15em', color: '#C8FF00', textTransform: 'uppercase', marginBottom: '16px' },
  h2:      { fontSize: 'clamp(2rem,4vw,3rem)', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '12px' },
  sub:     { color: '#888', marginBottom: '48px', fontSize: '1rem', lineHeight: 1.7 },
  form:    { display: 'flex', flexDirection: 'column', gap: '20px' },
  row:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
  group:   { display: 'flex', flexDirection: 'column' },
  label:   { fontSize: '0.82rem', color: '#888', marginBottom: '8px' },
  input:   { background: '#111', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '14px 16px', color: '#F0F0F0', fontSize: '0.95rem', outline: 'none' },
  textarea:{ background: '#111', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '14px 16px', color: '#F0F0F0', fontSize: '0.95rem', outline: 'none', minHeight: '140px', resize: 'vertical' },
  btn:     { background: '#C8FF00', color: '#000', border: 'none', padding: '16px', borderRadius: '100px', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' },
  success: { background: 'rgba(200,255,0,0.1)', border: '1px solid rgba(200,255,0,0.3)', borderRadius: '16px', padding: '32px', textAlign: 'center', fontSize: '1.1rem', color: '#C8FF00' },
};
